// Alma ERP — إدارة السوشل ميديا: القسم محجوز في القائمة، وسيُنقل محتواه من نظام رئال.
import React from "react";

export default function SocialPage() {
  return (
    <div className="page">
      <div className="page-head"><div><h1>📱 إدارة السوشل ميديا</h1><p>حسابات ألما المالية على المنصات، جدولة المنشورات، ومتابعة الأداء.</p></div></div>
      <div style={{ background: "#fff", border: "1px dashed #cbd5e1", borderRadius: 12, padding: 36, textAlign: "center", color: "#64748b", lineHeight: 1.9 }}>
        <div style={{ fontSize: 34 }}>📣</div>
        <div style={{ fontWeight: 900, color: "#0f172a", fontSize: 15 }}>هذا القسم قيد النقل من نظام رئال</div>
        <div style={{ fontSize: 13 }}>سيُنقل إليه «إدارة السوشل ميديا» بنفس الوظائف، على أن تكون بياناته مستقلة لشركة ألما المالية.</div>
      </div>
    </div>
  );
}
